import { render, staticRenderFns } from "./SkillsClassroom.vue?vue&type=template&id=14f5f36c&scoped=true"
import script from "./SkillsClassroom.vue?vue&type=script&lang=js"
export * from "./SkillsClassroom.vue?vue&type=script&lang=js"
import style0 from "./SkillsClassroom.vue?vue&type=style&index=0&id=14f5f36c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f5f36c",
  null
  
)

export default component.exports